import integrationResultService from "@services/integrationResult/integrationResultService"
import type { PagedResultDto } from "@services/dto/pagedResultDto"
import type { IIntegrationResult, IIntegrationResultFilter } from "@models/integrationResult/integrationResultModel"
import { action, makeAutoObservable, observable } from "mobx"

class IntegrationResultStore {
  @observable isLoading!: boolean
  @observable tableData!: PagedResultDto<IIntegrationResult>
  @observable detailData!: IIntegrationResult | null

  constructor() {
    makeAutoObservable(this)

    this.tableData = { items: [], totalCount: 0 }
    this.detailData = null
  }

  @action
  async getAll(params: IIntegrationResultFilter) {
    this.isLoading = true
    const result = await integrationResultService
      .getAll(params)
      .finally(() => (this.isLoading = false))
    this.tableData = result
  }

  @action
  async getDetail(id: number) {
    this.isLoading = true
    const result = await integrationResultService
      .getDetail(id)
      .finally(() => (this.isLoading = false))
    this.detailData = result
    return result
  }
}

export default IntegrationResultStore
